import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useOutsideClick } from '../../hooks/CommonHooks.jsx';
import './ReasonDropdown.scss';

export const ReasonDropdown = ({ reason, options, setReason }) => {
  const [open, setOpen] = useState(false);
  const [openDirection, setOpenDirection] = useState('down');
  const [maxOptionsHeight, setMaxOptionsHeight] = useState(180);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setOpen(false));
  const updateDropdownPosition = useCallback(() => {
    if (!dropdownRef.current) {
      return;
    }
    const { top, bottom } = dropdownRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const spaceAbove = top;
    const spaceBelow = viewportHeight - bottom;
    const nextDirection = spaceAbove > spaceBelow ? 'up' : 'down';
    const availableSpace = nextDirection === 'up' ? spaceAbove : spaceBelow;
    setOpenDirection(nextDirection);
    setMaxOptionsHeight(Math.max(40, Math.min(180, availableSpace - 12)));
  }, []);
  const toggleOpen = () => {
    if (!open) {
      updateDropdownPosition();
    }
    setOpen(!open);
  };
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    window.addEventListener('resize', updateDropdownPosition);
    window.addEventListener('scroll', updateDropdownPosition, true);
    return () => {
      window.removeEventListener('resize', updateDropdownPosition);
      window.removeEventListener('scroll', updateDropdownPosition, true);
    };
  }, [open, updateDropdownPosition]);
  const reasons = Object.keys(options)
    .map((key) => {
      const onClick = () => {
          setReason(key);
          setOpen(false);
      };
      return (
        <li className={'reason-option'} key={`reason-${key}`}>
          <button className={'reason-option-button very-light'} type={'button'} onClick={onClick}>
            {options[key].text}
          </button>
        </li>
      );
    });
  return (
    <section className={'reason-dropdown'} ref={dropdownRef}>
      <button
        className={`reason-button very-light ${open ? 'open' : ''}`}
        type={'button'}
        aria-expanded={open}
        onClick={toggleOpen}
      >
        {reason === null ? 'Select an option' : options[reason].text}
      </button>
      {open &&
        <ul className={`reason-options ${openDirection}`} style={{ maxHeight: `${maxOptionsHeight}px` }}>
          {reasons}
        </ul>
      }
    </section>
  );
};
